export type AttributionConsentState = 'granted' | 'denied' | 'unknown'
export type AttributionEndpointKind = 'touchpoint' | 'login' | 'register'

export type MarketingParams = Partial<{
  utm_source: string
  utm_medium: string
  utm_campaign: string
  utm_term: string
  utm_content: string
  gclid: string
  fbclid: string
}>

export type TouchpointPayload = {
  anonymous_id: string
  session_id: string
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
  referrer_url?: string
  landing_page: string
  page_url: string
  gclid?: string
  fbclid?: string
  event_type: string
  consent_given?: boolean
  metadata?: Record<string, unknown>
}

export type AuthAttributionFields = {
  anonymous_id?: string
  session_id?: string
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
  gclid?: string
  fbclid?: string
  referrer_url?: string
  landing_page?: string
  page_url?: string
  consent_given?: boolean
}

export type AttributionEndpointResolution = {
  primary: string
}

export const ATTRIBUTION_ALLOWLIST_PATH_PREFIXES = ['/login', '/upgrade', '/subscribe', '/checkout', '/pricing']

export const ATTRIBUTION_SESSION_TIMEOUT_MS = 30 * 60 * 1000

export const ATTRIBUTION_STORAGE_KEYS = {
  anonymousId: 'cr_aid', // Ensure compatibility with external tools that might look for this specific key
  sessionId: '_crate_sid',
  lastActivity: '_crate_last_activity',
  utm: '_crate_utm',
  referrer: '_crate_referrer',
  landingPage: '_crate_landing_page',
  consent: '_crate_consent',
} as const
